import { Component, ViewChild, ElementRef, NgZone } from '@angular/core';

import { Platform, NavParams, ModalController, ActionSheetController, App, NavController, LoadingController, ToastController, Config } from 'ionic-angular';
import { Subscription, Subject } from 'rxjs';
import { timer } from 'rxjs/observable/timer';
import { LocationProvider } from '../location-handler';
import { EventDetailsModel, EventProvider } from '../../providers/event/event';
import { ResultProvider } from '../../providers/result/result';
import { TrackingSettingsPage } from '../../pages/tracking-settings/tracking-settings';
import { StepDetector } from '../step-detector';
import { DeviceMotion, DeviceMotionAccelerationData } from '@ionic-native/device-motion';
import { GpsTracker } from '../gps-tracker';
import { AudioSystemProvider } from '../../providers/audio-system/audio-system';
import { TranslateService } from '@ngx-translate/core';
import { MysportResultsPage } from '../../pages/me/mysport/mysport-results/mysport-results';
import { UserProvider } from '../../providers/user/user';
import { Storage } from '@ionic/storage';
import { RouteMarathon, StrackerProvider, TrackerModel } from '../../providers/stracker/stracker';
import { SessionProvider } from '../../providers/session/session';
import { Device } from '@ionic-native/device';
import { StepController } from '../step-controller';
import { PermissionPage } from './tutorial-permission/permission';
import { ConfigProvider } from '../../providers/config/config';
import { StorageProvider } from '../../providers/storage-service/storage-service';
import { AutoPause, ObserverGeneral, SubjectGeneral } from '../autopause/autopause';
import { ResultDescriptionPage } from '../../pages/results/result-description/result-description';
import { AppDetectorProvider } from '../../providers/detector/detector';
import { IconPipe } from '../../pipes/icon/icon';
import { StrackerUtils } from './stracker-utils';
import { LocationHandlerUtil } from '../location-handler-utils';
import { AdsProvider } from '../../providers/ads/ads';
import L from 'leaflet';
import * as LO from 'leaflet.offline';
import { RunStatistics } from '../run-statistics/run-statistics';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { getTileUrls, getStorageInfo, truncate, downloadTile, saveTile } from 'leaflet.offline';
import { DistanceUnit, TrackingService, TrackingSettings } from '../../providers/tracking.service';

declare var google;

@Component({
    selector: 'stracker-page',
    templateUrl: 'stracker.html',
})
export class StrackerPage implements ObserverGeneral {
    @ViewChild('map') mapElement: ElementRef;
    map: any;

    @ViewChild('bib') bibElement: ElementRef;

    locater: LocationProvider;
    clock = null;
    state: boolean = false;
    modal = null;
    activityType: number = -1;
    paused: boolean = false;
    localConfig = null;
    started = false;
    event: EventDetailsModel;
    stepDetector: StepDetector = null;
    steps = 0;
    data: TrackerModel = null;
    hasDistance: boolean = false;

    stepController: StepController = new StepController();

    controllerScope: boolean;
    reachedSub: Subject<boolean> = new Subject();
    reachedStartingPointSub: Subject<boolean> = new Subject();
    onLocationSub: Subject<boolean> = new Subject();
    stepIncreaseSub: Subject<any> = new Subject();

    raceFinished: boolean = false;
    actionPresented: boolean = false;
    viewClose: Promise<any> = null;

    lastSumDistanceForBG: number = 0;
    lastSteps: number = 0;

    viewResolver = null;

    imageLink = null;
    isMap: boolean = false;
    dataSent = false;

    view = {
        average_pace: "0",
        average_speed: "0.0"
    }

    saveTilesSub: Subscription = null;
    token: string = "";
    appName: string = "";

    testMode: boolean = false;

    // UI elements
    showheader: boolean = true;
    hideheader: boolean = false;
    settingsButton: boolean = false;
    isStopPressed: boolean = false;
    isPlayDisabled: boolean = false;
    stopAllowed: boolean = false;
    warningMessage: boolean = false;

    color: string = "black";
    colorIcon: string = "black";
    bgColor: string = "white";

    //apps
    isEvents: boolean = false;
    isThurnau: boolean = false;
    isHella: boolean = false;
    isHannover: boolean = false;

    //ADAC Hannover
    eventId: any;
    route: RouteMarathon = {
        hasRoute: false,
        fullPath: []
    };
    runStatistics: RunStatistics;

    allowCountdown: boolean = true;
    isMapPreloaded: boolean = true;
    baseLayer;
    urlTemplate = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    finishMarker;
    startMarker;
    activeItem: any = {
        participants: [],
        markers: []
    };
    followerSub: Subscription = null;
    updateViewSub: Subscription = null;
    activeDateFormat: string;
    isPremium:boolean=false;
    constructor(
        public platform: Platform,
        private navParams: NavParams,
        private resultService: ResultProvider,
        private modalCtrl: ModalController,
        private deviceMotion: DeviceMotion,
        private audioService: AudioSystemProvider,
        private actionSheetCtrl: ActionSheetController,
        private translate: TranslateService,
        private app: App,
        private loadingCtrl: LoadingController,
       private userService: UserProvider,
        private storage: Storage,
        private strackerService: StrackerProvider,
        private sessionService: SessionProvider,
        private device: Device,
        private config: ConfigProvider,
        private storageService: StorageProvider,
        private zone: NgZone,
        private toastCtrl: ToastController,
        private appDetector: AppDetectorProvider,
        private trackingService: TrackingService,
        private eventService: EventProvider,
        private icons: IconPipe,
        private adsProvider: AdsProvider) {
            this.route = this.navParams.get("route");
            if(typeof this.route.fullPath==='undefined'){
                this.route.hasRoute=false;
            }
            this.data = this.navParams.get("data");
            this.imageLink = this.navParams.get("imageLink");
            this.token = this.navParams.get("token");
            this.event = this.navParams.get("event");
            this.eventId = this.navParams.get("eventId");

        async () => { this.settingsButton = (await this.config.config).showHide.showTrackerSettingsIcon; };
        this.viewClose = new Promise<any>((resolve, reject) => {
            this.viewResolver = resolve;
        });
        this.preloadSettings();
        AutoPause.getInstance().attach(this);
        this.initialize();
        this.startTimers();     
    }
    startTimers(){
        if (!this.updateViewSub) {
            this.updateViewSub = timer(0, 5000).subscribe(() => {
                if ((this.appDetector.isHellaApp() || this.appDetector.isForestApp() || this.appDetector.isThurnauApp()) && this.started)
                    this.runStatistics.writeRoutePoints();

                this.getCurrentSpeed();
                this.getAverageSpeed();
            });
        }
        if (this.appDetector.isHannoverApp() || this.appDetector.isForestApp()) {
            this.onLocationSub.subscribe((location: any) => {
                let coords = { lat: location.coords.latitude, lng: location.coords.longitude };
                this.path.push(coords);
                this.saveTiles();
            });
        }
        if (!this.followerSub) {
            this.followerSub = timer(0, 2000).subscribe(() => {
                // this.getParticipantsLocations().then(participantsLocations => {
                //     this.displayParticipants(participantsLocations).then(() => {
                //         this.updateParticipantsMarkers().then(() => {
                //         });
                //     });
                // });
            });
        }     
    }

    getParticipantsLocations(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            if (!this.event.id) { reject("[ERROR] no event id or eventId found"); return; }
            console.log('this.activeItem.participants', JSON.stringify(this.activeItem.participants))
            //     this.eventService.getNearbyParticipantPosititons(this.activeItem.participants.map(p => p.lid), this.event.id).then(participantsLocations => {
            //         console.log('got participants locations', JSON.stringify(participantsLocations))
            //         resolve(participantsLocations);
            //     }).catch(err => {
            //         console.error('error while fetching the participants locations ' + err);
            //         reject(err);
            // });
        });
    }     
    displayParticipants(locations): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            for (let i = 0; i < this.activeItem.participants.length; i++) {
                let locIndex = locations.findIndex(loc => loc.lid == this.activeItem.participants[i].lid);
                if (locIndex < 0) continue;
                let index = this.activeItem.markers.findIndex(m => {m.lid == this.activeItem.participants[i].lid});
                if (index < 0) {
                    // create
                    let marker = new L.Marker([0, 0]);
                    let icon = L.icon({
                        iconUrl: this.activeItem.participants[i].img,
                        iconSize: [35, 35]
                    });
                    marker.setIcon(icon);
                    marker.addTo(this.map);
                    marker.setLatLng(L.latLng(locations[locIndex].lat, locations[locIndex].lng));
                    this.activeItem.markers.push({ marker: marker, lid: this.activeItem.participants[i].lid });
                } else {
                    // update
                    this.activeItem.markers[index].marker.setLatLng(L.latLng(locations[locIndex].lat, locations[locIndex].lng));
                    this.activeItem.markers[index].marker.update();
                }
            }
            resolve(this.activeItem.markers);
        });
    }       
    updateParticipantsMarkers(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            for (let i = 0; i < this.activeItem.markers.length; i++) {
                let indexOf = this.activeItem.participants.length ? this.activeItem.participants.findIndex(f => f.lid == this.activeItem.markers[i].lid) : -1;
                if (indexOf < 0) {
                    const element = this.activeItem.markers[i].marker;
                    // setTimeout(()=>{
                    //     try{
                    //         this.map.removeLayer(element);
                    //     }catch (err){
                    //         console.log('error in remove marker', JSON.stringify(err))
                    //     }
                    // },5000)
                    if (this.activeItem.participants[i]){
                        this.activeItem.markers = this.activeItem.markers.filter(m => m.lid != this.activeItem.participants[i].lid);
                    }
                }
            }
        });
    }

    clearParticipantsMarkers(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            for (let i = 0; i < this.activeItem.markers.length; i++) {
                // let locIndex = this.activeItem.participants.findIndex(p => p.lidOrRaceResultId == this.activeItem.markers[i].lid);
                // if (locIndex < 0) {
                const element = this.activeItem.markers[i];
                this.map.removeLayer(element);
                delete this.activeItem.markers[i];
                // }
            }
            this.activeItem.markers = [];
            resolve([]);
        });
    }

    initialize() {

        // Global variable, used to check if the news can be updated
        GpsTracker.isRunning = true;

        // Thurnau app has the endless distance
        this.hasDistance = (this.event.streckeconv.toLocaleLowerCase().includes('var')) ? false : true;

        this.stopAllowed = this.event.eventType === "V" ? false : true;
        console.log('this.event.eventType.', this.event.eventType)
        if (this.event.eventType =="R") this.stopAllowed = false
    }

    async drawRoute() {
        let needLocation = this.appDetector.isHannoverApp() || this.appDetector.isForestApp();
        if (typeof this.locater === "undefined") {
            this.locater = new LocationProvider(
                this.map,
                this.reachedSub,
                this.event,
                this.zone,
                this.toastCtrl,
                this.platform,
                this.reachedStartingPointSub,
                this.storageService,
                this.appDetector,
                this.trackingService.options.google,
                needLocation ? this.onLocationSub : null
            );
        }
        console.log('draw route')
        this.getLocater().getMapHandler().newPoly();
        this.getLocater().getMapHandler().setPolyDestinations(this.route.fullPath);
        this.getLocater().getMapHandler().drawPolyLines(true);
        this.getLocater().getMapHandler().setMapCenterLatLng(this.route.fullPath[0]);

        let coords = [];
        coords.push(this.route.fullPath[0]);
        coords.push(this.route.fullPath[this.route.fullPath.length - 1]);

        let icons = {
            start: await this.icons.transform(this.event.cid + '', 'marker'),
            finish: await this.icons.get('marker', 'finish')
        };

        this.getLocater().getMapHandler().drawStartFinishMarkersLatLng(coords, icons);
    }

    update(subject: SubjectGeneral): void {
        if (subject instanceof AutoPause) {
            this.stopTrack(false);
        }
    }

    preloadSettings() {
        this.storageService.checkForExistance('stop-button-' + this.event.id + "-" + this.token).then((status) => {
            if (status) this.strackerService.getSaved('stop-button-' + this.event.id + "-" + this.token).then((data) => this.isStopPressed = data);
        });
    }

    locationPermission(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            resolve(null);
        });
    }

    permissionRequest(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.storage.keys().then((data) => {
                let table = data.includes("ios-perm-check-" + this.appName);
                if (table) {
                    resolve(true);
                } else {
                    resolve(false);
                }

            })
        });
    }

    permissionWrite(): Promise<any> {
        return this.strackerService.saveData(true, ("ios-perm-check-" + this.appName));
    }

    onResultsRedirect() {
        this.sendData();
    }

    initPreload() {
        if (this.data) {
            GpsTracker.sumDistance = this.data.distance;
            this.getLocater().setCurrentDuration(this.data.time);
            // GpsTracker.currentSpeed = (this.getLocater().getCurrentDuration() / (GpsTracker.sumDistance / 1000)); // pace
            GpsTracker.currentSpeed = LocationHandlerUtil.calcPace(GpsTracker.sumDistance, this.getLocater().getCurrentDuration());
            this.view.average_pace = this.data.average_pace;
            this.view.average_speed = this.data.average_speed + "";
            this.raceFinished = this.data.finished;
        }
    }

    onMapToggle() {
        this.isMap = !this.isMap;
    }

    triggerPauseResume() {
        this.platform.ready().then(() => {

            if (this.platform.is('cordova')) {

                //Subscribe on pause i.e. background
                this.platform.pause.subscribe(() => {
                    GpsTracker.isBackground = true;
                    this.lastSumDistanceForBG = GpsTracker.sumDistance;
                    this.lastSteps = this.stepDetector.stepCount;
                    this.saveData(false);
                });

                //Subscribe on resume i.e. foreground 
                this.platform.resume.subscribe(() => {

                    //Calculate the steps in background mode
                    GpsTracker.isBackground = false;

                    this.locater.setCurrentTime();
                    this.calculateBgSteps();
                    this.invokeMenu();

                    // this.getPermission();
                });
            }
        });
    }

    ionViewWillLeave() {
        if (!this.sessionService.isLoged) return;
        this.stopTrack(false);
        this.saveData(false);

        if (this.stepCountSub) {
            this.stepCountSub.unsubscribe();
            this.stepCountSub = null;
        }

        if (this.onLocationSub) {
            this.onLocationSub.unsubscribe();
            this.onLocationSub = null;
        }

        if (this.followerSub) {
            this.followerSub.unsubscribe();
            this.followerSub = null;
        }

        if (this.updateViewSub) {
            this.updateViewSub.unsubscribe();
            this.updateViewSub = null;
        }

        // Force termination
        this.getLocater().terminate(true);
        this.getLocater().clear();
        this.getLocater().DISTANCE_TO_WIN = null;
        GpsTracker.isRunning = false;
        this.getLocater().pluginTerminate();
        this.getLocater().getMapHandler().destroy();
        //this.getLocater().map = null;
        //this.locater = null;
        //this.getLocater().config.mapHandler  = null;
        if(!this.isPremium) this.adsProvider.show();
    }
    ionViewDidLeave(){
        if(!this.isPremium) this.adsProvider.show();
    }

    getAveragePace(pace) {
        if (this.trackingService.options.distanceUnit == DistanceUnit.MILES) {
            return (Number(pace) * 1.60934).toFixed(1);
        }
        return pace;
    }

    getAvSpeed(speed) {
        if (this.trackingService.options.distanceUnit == DistanceUnit.MILES) {
            return (Number(speed) * 0.621371).toFixed(1);
        }
        return speed;
    }


    saveData(finished) {
        if (finished) {
            this.strackerService.pushDataFinished(this.prepareSaveData()).then(() => {
            });
        } else {
            this.strackerService.pushDataNotFinished(this.prepareSaveData()).then(() => {
            });
        }
    }

    prepareSaveData() {
        let obj: TrackerModel = {
            eventId: this.event.id,
            token: this.token,
            time: this.getLocater().getCurrentDuration(),
            distance: GpsTracker.sumDistance,
            finished: this.raceFinished,
            average_pace: this.getCurrentSpeed(),
            average_speed: this.getAverageSpeed()
        }
        return obj;
    }


    prepareSaveDataTEST(status: boolean) {
        let obj = null;
        if (status) {
            obj = {
                eventId: this.event.id,
                token: this.token,
                time: Math.floor(100 * Math.random()),
                distance: 5000,
                finished: true,
                average_pace: 5,
                average_speed: 5,
                path: this.getMapPath()
            }
        } else {
            obj = {
                eventId: this.event.id,
                token: this.token,
                time: Math.floor(100 * Math.random()),
                distance: 4900,
                finished: false,
                average_pace: 0,
                average_speed: 0,
                path: this.getMapPath()
            }
        }
        return obj;
    }

    getMapPath() {
        return this.getLocater().getMapPath();
    }

    invokeMenu() {
        if (this.raceFinished && !this.actionPresented && (GpsTracker.sumDistance >= this.getLocater().DISTANCE_TO_WIN)) {
            this.viewResolver();
            // 1. change icon
            this.raceFinished = true;

            // this.presentActionSheet();
            this.actionPresented = true;

            // 2. save data
            this.saveData(true);

            this.strackerService.remove();
            // 3. call the endpoint
            this.sendData();
        }
    }

    saveTest() {
        // this.strackerService.pushDataFinished(this.prepareSaveDataTEST(true));
        this.strackerService.pushDataFinished(this.prepareSaveDataTEST(true));
    }

    getTest() {
        this.strackerService.getResultPreload(this.event.id, this.token).then((model) => {
            this.data = model;

            this.initPreload();
        });
    }

    presentActionSheet() {
        const actionSheet = this.actionSheetCtrl.create({
            title: this.translate.instant('RACE_FINISHED'),
            buttons: [
                {
                    text: 'OK',
                    role: 'destructive',
                    handler: () => {
                        this.openResults();
                    }
                },
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                    }
                }
            ]
        });
        actionSheet.present();
        this.actionPresented = true;
    }


    onTest() {
        this.warningMessage = false;
    }

    async openResults(timeout?: number) {
        if (navigator.onLine) {
            if (this.appDetector.isHellaApp() || this.appDetector.isThurnauApp()) {
                if (this.route.hasRoute) {
                    this.runStatistics.hasRoute = true;
                    this.runStatistics.routePoints = Object.assign([], this.route.fullPath);
                }
                (this.app.getRootNav() as NavController).push(ResultDescriptionPage, { statisticsResults: this.runStatistics.getWrappedStatistics(), registration: this.imageLink });
            } else {
                this.userService.getMyResults().then(results => {
                    (this.app.getRootNav() as NavController).push(MysportResultsPage, { results: results });
                });
            }
        }
    }

    calculateBgSteps() {
        if (this.lastSteps != 0) {

            let average = Math.round(this.lastSumDistanceForBG / this.lastSteps);
            let diff = Math.round(GpsTracker.sumDistance - this.lastSumDistanceForBG);

            this.stepDetector.stepCount += (diff * average);
        }
    }

    async ionViewDidLoad() {
        this.isPremium = Boolean(JSON.parse(localStorage.getItem('premium'))) || false;
        // if (this.event)
        // this.storageService.getSaved("participants-" + this.event.id).then((c) => {
        //     // this.activeItem.participants = Object.assign([], c);
        //     this.activeItem.participants = c
        // });
        // console.log('participants', JSON.stringify(this.activeItem.participants))
        this.firstStart();

        this.trackingService.options.google ? this.loadGoogleMaps() : this.loadLeafletMaps();

        this.color = (await this.config.config).theme.color;
        this.colorIcon = (await this.config.config).theme.color;

        this.appName = (await this.config.config).appId;

        this.isHella = (this.appName.includes('hellamarathon')) ? true : false;
        this.isThurnau = (this.appName.includes('thurnau')) ? true : false;
        this.isEvents = (this.appName.includes('event')) ? true : false;

        this.preloadUI();
    }

    preloadUI() {
        if (this.isHella) {
            // we disable the map button
            this.onMapToggle();
            this.color = this.colorIcon = "white";
            this.bgColor = "#002f5d";
        } else if (this.isEvents) {
            this.color = this.colorIcon = "black";
            this.bgColor = "white";
        } else if (this.isThurnau) {
            this.color = "black";
        }
    }

    async getPermission() {
        if (this.platform.is('ios')) {
            this.permissionRequest().then((check) => {
                if (!check || this.getLocater().authStatus !== 1) {
                    this.permissionWrite().then(() => {
                        this.goPermissionPage("ios");
                    });
                }
            });
        } else if (this.platform.is('android') && (this.device.version.includes("11"))) {
            this.permissionRequest().then((check) => {
                if (!check) {
                    this.permissionWrite().then(() => {
                        this.goPermissionPage("android");
                    });
                }
            });
        }
    }

    goPermissionPage(OS: string) {
        (this.app.getRootNav() as NavController).push(PermissionPage, { os: OS });
    }

    saveStatistics() {
        this.runStatistics.add().then(() => {
            this.runStatistics.save();
        });
    }

    firstStart() {
        this.platform.ready().then(() => {
            let needLocation = this.appDetector.isHannoverApp() || this.appDetector.isForestApp();
            this.locater = new LocationProvider(
                this.map,
                this.reachedSub,
                this.event,
                this.zone,
                this.toastCtrl,
                this.platform,
                this.reachedStartingPointSub,
                this.storageService,
                this.appDetector,
                this.trackingService.options.google,
                needLocation ? this.onLocationSub : null
            );


            this.initSubscription();
            this.getLocater().placementEnabled = this.trackingService.options.placement;
            this.stepDetector = new StepDetector(this.stepIncreaseSub);
            this.initPreload();
            this.triggerPauseResume();
            if (this.appDetector.isHellaApp() || this.appDetector.isHannoverApp() || this.appDetector.isForestApp()) {
                this.runStatistics = new RunStatistics({ localDb: this.storageService, locater: this.locater, event: this.eventService }, this.event);

                if (this.sessionService.isLoged) {
                    const userId = this.sessionService.profile.id;
                    this.runStatistics.writeUserId(userId);
                    this.activeItem.id = typeof this.event === "undefined" ? -1 : this.event.id;
                    this.strackerService.getResultPreload((typeof this.event === "undefined") ? -1 : this.event.id, userId + "").then((data: TrackerModel) => {
                        this.data = data;
                        this.runStatistics.load();
                        this.initPreload();
                    });
                }

                this.runStatistics.writeEventCid(this.event.cid);
            }

            this.stepIncreaseSub.subscribe(() => {
                this.getLocater().setLastStep(new Date().getTime());
            });
        });

    }

    testfinish() {
        GpsTracker.sumDistance = 1000;
        this.saveStatistics();
        this.raceFinished = true;
        this.distanceReached();
    }


    initSubscription() {
        try {
            this.reachedSub.subscribe((final) => {
                if (!this.raceFinished) {
                    if (this.appDetector.isHellaApp() || this.appDetector.isThurnauApp() || this.appDetector.isForestApp() || this.appDetector.isHannoverApp()) {
                        this.saveStatistics();
                    }

                    if (final) {
                        this.raceFinished = true;
                        this.distanceReached();
                    } else if (!final) {
                        this.audioService.playAudio(GpsTracker.isBackground, false, this.trackingService.options.applause);
                    }
                }
            });

            this.reachedStartingPointSub.subscribe((status) => {
                if (!this.raceFinished)
                    if (status && this.route.hasRoute) {
                        this.isPlayDisabled = false;
                        this.warningMessage = false;
                    }
            });

            if (this.appDetector.isHannoverApp() || this.appDetector.isForestApp()) {
                this.onLocationSub.subscribe((location: any) => {
                    this.path.push({ lat: location.coords.latitude, lng: location.coords.longitude });
                    if (!navigator.onLine || !this.trackingService.options.locationExport) return;

                    this.saveTiles();
                });
            }
        } catch (err) {
            console.log("error while init subscription " + err);
        }
    }

    path = [];
    saveTiles() {
        let points = this.path.map(coords => L.point(coords.lat, coords.lng));
        let bounds = L.bounds(points);
        let urls = getTileUrls(this.baseLayer, bounds, 16);
        for (let i = 0; i < urls.length; i++) {
            downloadTile(urls[i].url).then(blob => {
                saveTile(urls[i], blob).then(() => {
                });
            });
        }
    }


    distanceReached() {
        this.audioService.playAudio(GpsTracker.isBackground, true, this.trackingService.options.applause);
        this.stop(false);
        if (!GpsTracker.isBackground) {
            this.invokeMenu();
        }
        this.strackerService.remove();
    }

    sendData(distance = null) {
        if (this.appDetector.isHellaApp()) {
            this.prepareRunStatisticsData().then((runStatistics) => {
                if (navigator.onLine) {
                    let d = (distance) ? parseInt(distance) : null;
                    this.resultService.sendVirtualResults(runStatistics, d).then(() => {
                        this.storage.remove('resultVirtual');
                        this.openResults();
                    }).catch((err) => console.log('error while sending data ' + err));
                } else {
                    this.noConnectionSave(runStatistics);
                }
            });
        } else {
            this.prepareData().then((obj) => {
                if (navigator.onLine) {
                    let d = (distance) ? parseInt(distance) : null;
                    this.resultService.sendVirtualResults(obj, d).then(() => {
                        this.storage.remove('resultVirtual');
                        this.openResults();
                    }).catch((err) => console.log('error while sending data ' + err));
                } else {
                    this.noConnectionSave(obj);
                }
            });
        }
    }

    prepareRunStatisticsData() {
        return new Promise<any>((resolve, reject) => {
            let encodedPath = "";
            try {
                encodedPath = google.maps.geometry.encoding.encodePath(this.runStatistics.routePoints);
            } catch (err) {
                console.log(err);
            }
            let encodedStatistics = encodeURI(JSON.stringify(this.runStatistics.kmStatistics));
         

            const totalAltitude = LocationHandlerUtil.calcAltitude(this.runStatistics.kmStatistics.map(x => x.gain));

            let object = {
                cid: this.event.cid,
                eventId: this.event.id,
                timeSec: this.getDeepDuration(),
                routeStrn: encodedPath,
                detailSplitStrn: encodedStatistics,
                heightInMeterTotal: totalAltitude
            }

            let data = JSON.stringify(object);
            this.storage.set('resultVirtual', data).then(() => {
                resolve(object);
            });
        });
    }

    noConnectionSave(obj) {
        let loading = this.loadingCtrl.create({
            content: this.translate.instant('NO_CONNECTION_SAVE'),
            duration: 10000
        });
        loading.present();

        window.addEventListener('online', () => {
            if (!this.dataSent) {
                this.resultService.sendVirtualResults(obj).then(() => {
                    this.dataSent = true;
                    this.storage.remove('resultVirtual').then(() => {
                        loading.dismiss();
                        this.openResults(10000);
                    });
                });
            }
        });
    }

    onConfigureModal() {
        const modal = this.modalCtrl.create(TrackingSettingsPage);
        if (this.token.length > 0) localStorage.setItem('token', this.token);
        localStorage.setItem('eventId', this.event.id + "");

        modal.onDidDismiss(() => {
            this.trackingService.updateTrackingSettings();
            if (this.trackingService.options.autoPause) AutoPause.getInstance().run();
            this.trackingService.options.placement ? this.getLocater().setPlacement(true) : this.getLocater().removePlacement();
        });

        modal.present();
    }

    restartTrack() {
        const actionSheet = this.actionSheetCtrl.create({
            title: this.translate.instant('RESTART_ROUND'),
            buttons: [
                {
                    text: this.translate.instant('GLOBAL_YES'),
                    role: 'destructive',
                    handler: () => {
                        if (this.getLocater().getCurrentDuration() == 0 && GpsTracker.sumDistance == 0) {
                            return;
                        }

                        this.strackerService.remove();
                        this.getLocater().clear();
                        this.clear();
                        this.stopTrack(false, true);
                        this.enableStopButton();

                        this.getLocater().setSubscriptions(this.reachedSub, this.reachedStartingPointSub);

                        this.actionPresented = false;
                        this.raceFinished = false;
                        GpsTracker.sumDistance = 0;

                        /*
                        UI function,
                        when the user clicks pause we hide the toolbar
                        if the auto pause is triggered we don't hide one
                        */
                        this.showheader = true;
                        this.hideheader = false;

                        if (this.route.hasRoute) {
                            this.isPlayDisabled = true;
                            this.warningMessage = true;
                        }

                        this.stepController.clear();

                    }
                },
                {
                    text: this.translate.instant('GLOBAL_NO'),
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                }
            ]
        });
        actionSheet.present();
    }

    clear() {
        this.view.average_speed = "0.0";
        this.view.average_pace = "0";
        this.runStatistics.reset();
        this.runStatistics.delete();
        this.storageService.removeData('statistics-results-' + this.event.id + "-" + this.token).catch((err) => 'Error: while clearing statistics results');
        this.allowCountdown = true;

        if (!this.route.hasRoute) this.getLocater().getMapHandler().clearNearestMarkers();

        if (this.data) {
            this.data.average_pace = "0";
            this.data.average_speed = "0.0";
            this.data.distance = 0;
            this.data.finished = false;
            this.data.time = 0;
        }
    }

    getStarted() {
        return this.started;
    }

    prepareData() {
        return new Promise<any>((resolve, reject) => {
            let object = {
                cid: this.event.cid,
                eventId: this.event.id,
                timeSec: this.getDeepDuration()
            }

            let data = JSON.stringify(object);
            this.storage.set('resultVirtual', data).then(() => {
                resolve(object);
            });
        });
    }

    loadGoogleMaps() {
        try {
            this.platform.ready().then(() => {
                var that = this;
                let loadMaps = setInterval(() => {
                    if (typeof google !== "undefined" && window.navigator.onLine) {

                        let mapConfig = {
                            zoom: 16,
                            center: { lat: 52.5204345, lng: 13.4014027 },
                            mapTypeId: google.maps.MapTypeId.TERRAIN,
                            disableDefaultUI: true
                        };

                        that.locater.setMap(new google.maps.Map(that.mapElement.nativeElement, mapConfig));

                        this.drawEventWithRoute();

                        clearInterval(loadMaps);
                    }
                }, 400);
            });
        } catch (err) {
            console.log('loadMaps error = ' + err);
        }
    }

    loadLeafletMaps() {
        setTimeout(() => {
            this.initMapConfigs();
            this.getLocater().setMap(this.map);
            this.drawEventWithRoute();
            this.boundLeaflet();
        }, 400);
    }

    initMapConfigs() {
        let map = this.navParams.get("map");

        if (typeof map !== "undefined") {
            map.remove();
        }

        this.map = (L as any).map('map');

        let zoomLevel = (this.route.hasRoute) ? 1 : 16;

        this.baseLayer = (L as any).tileLayer
            .offline(this.urlTemplate, {
                attribution: 'Map data {attribution.OpenStreetMap}',
                subdomains: 'abc',
                minZoom: zoomLevel,
            })
            .addTo(this.map);



        this.map.setView(
            {
                lat: 52.5204345,
                lng: 13.4014027,
            },
            16
        );

        // add buttons to save tiles in area viewed
        const control = (L as any).control.savetiles(this.baseLayer, {
            zoomlevels: [16, 16], // optional zoomlevels to save, default current zoomlevel
            confirm(layer, successCallback) {
                // eslint-disable-next-line no-alert
                // if (window.confirm(`Save ${layer._tilesforSave.length}`)) {
                successCallback();
                // }
            },
            confirmRemoval(layer, successCallback) {
                // eslint-disable-next-line no-alert
                if (window.confirm('Remove all the tiles?')) {
                    successCallback();
                }
            },
            saveText:
                '<i class="fa fa-download" aria-hidden="true" title="Save tiles"></i>',
            rmText: '<i class="fa fa-trash" aria-hidden="true"  title="Remove tiles"></i>',
        });
        control.addTo(this.map);

        let progress;
        this.baseLayer.on('savestart', (e) => {
            progress = 0;
        });
        this.baseLayer.on('savetileend', () => {
            progress += 1;
        });
    }

    boundLeaflet() {
        setTimeout(() => {
            if (this.route.hasRoute && this.warningMessage) {
                let markerArray = [];
                for (let i = 0; i < this.route.fullPath.length; i++) {
                    markerArray.push(L.marker([this.route.fullPath[i].lat(), this.route.fullPath[i].lng()]));
                }
                let center = this.getLocater().getMapHandler().getCenter();
                markerArray.push(L.marker([center.lat, center.lng]));
                let group = L.featureGroup(markerArray);
                this.map.fitBounds(group.getBounds());
            }
        }, 4000);
    }

    drawEventWithRoute() {
        if (this.route.hasRoute) {
            this.drawRoute();
            this.isPlayDisabled = true;
            this.warningMessage = true;
            this.getLocater().hasRoute = true;
            this.getLocater().startingPoint = this.route.fullPath[0];
            this.getLocater().finishPoint = this.route.fullPath[this.route.fullPath.length - 1];
        } else {
            this.isPlayDisabled = false;
        }
    }

    stepCountSub: any;
    startTrack() {
        this.sessionService.getToken(false, false).then(token => {
            this.token = this.sessionService.profile.id + "";

            this.runStatistics.writeUserId(this.sessionService.profile.id);

            if (!this.started || !this.getLocater().stopWatch) {

                if (this.allowCountdown) {

                    this.allowCountdown = false;

                    // const modal = this.modalCtrl.create(CountdownComponent, { countdownBg: CountdownBg.APPLAUSE });

                    // modal.onDidDismiss(option => {
                    //     console.log("onDidDismiss " + option);
                    this.startConfigs();
                    // });

                    // modal.present();
                } else {
                    this.startConfigs();
                }
            }
        });
    }

    startConfigs() {
        try {
            this.started = true;
            this.showheader = false;
            this.hideheader = true;
            this.getLocater().startTrack((this.data) ? this.data.time : 0);
            if (!this.stepCountSub) this.runAccel();
            this.initPreload();

            if (this.route.hasRoute) {
                this.getLocater().setMapCenter(16);
                this.getLocater().getMapHandler().disableZoom();
            }
        } catch (err) {
            console.log('start track error = ' + err);
        }

        AutoPause.getInstance().setEnabled(this.trackingService.options.autoPause);

        if (this.trackingService.options.autoPause) AutoPause.getInstance().run();
    }

    runAccel() {
        this.stepDetector.clear();

        try {
            this.stepCountSub = this.deviceMotion.watchAcceleration({ frequency: 100 }).subscribe((acceleration: DeviceMotionAccelerationData) => {
                let step = this.stepDetector.isAStep(acceleration.x, acceleration.y, acceleration.z);
                this.steps = this.stepDetector.stepCount;
                if (step) {
                    if (!AutoPause.getInstance().isRunning() && !this.started && this.getLocater().autoStartTrigger) {
                        this.startTrack();
                    }
                    AutoPause.getInstance().setLastAction(new Date());
                }
            });
        } catch (err) {
            console.log("Accel. Error = " + err);
        }
    }

    stopTrack(pause: boolean, restart: boolean = false) {
        AutoPause.getInstance().setRunning(false);

        if (this.started || this.getLocater().stopWatch) {
            this.data = null;
            this.getLocater().stopTrack();
            this.started = false;

            if (!restart) {
                this.runStatistics.updateMainRunStatistics().then(() => {
                    this.runStatistics.save();
                })
            }
        }

        if (pause) {
            if (this.stepCountSub) {
                this.stepCountSub.unsubscribe();
                this.stepCountSub = null;
            }
            this.getLocater().pluginTerminate();
        }
    }

    stop(pause: boolean) {
        /*
            UI function,
            when the user clicks pause we hide the toolbar
            if the auto pause is triggered we don't hide one
        */
        this.showheader = true;
        this.hideheader = false;

        this.stopTrack(pause);
    }

    /*
    // Stop tracking when there is no distance in the event. 
    */
    fullStop(pause: boolean) {
        // if (this.started) {
        this.stop(pause);
        const actionSheet = this.actionSheetCtrl.create({
            title: this.translate.instant('FULL_STOP_MESSAGE'),
            buttons: [
                {
                    text: this.translate.instant('GLOBAL_YES'),
                    role: 'destructive',
                    handler: () => {

                        this.raceFinished = true;

                        // 2. save data
                        this.saveData(true);
                        this.strackerService.remove();
                        this.sendData(GpsTracker.sumDistance);
                        this.disableStopButton();
                    }
                },
                {
                    text: this.translate.instant('GLOBAL_NO'),
                    role: 'cancel',
                    handler: () => {
                        this.startTrack();
                    }
                }
            ]
        });
        actionSheet.present();
        // }
    }

    disableStopButton() {
        this.strackerService.saveData(true, ("stop-button-" + this.event.id + "-" + this.token)).then(() => {
            this.isStopPressed = true;
        });
    }

    enableStopButton() {
        this.strackerService.saveData(false, ("stop-button-" + this.event.id + "-" + this.token)).then(() => {
            this.isStopPressed = false;
        });
    }

    isStopDisabled() {
        return (GpsTracker.sumDistance > 0) ? false : true;
    }

    getCurrentSpeed() {
        let num = (typeof this.getLocater() !== "undefined") ? this.getLocater().getCurrentSpeed() : "0";
        this.view.average_pace = num;
        return this.view.average_pace;
    }

    getDeepDuration() {
        return (typeof this.getLocater() !== "undefined") ? this.getLocater().getCurrentDuration() : 0;
    }

    getCurrentDuration() {
        return StrackerUtils.transormSeconds(this.getDeepDuration());
    }

    getAverageSpeed() {
        let sec = this.getDeepDuration();
        let dist = Number(this.getDeepDistance()); // already in km
        if (sec == 0) {
            return 0;
        }
        let result = dist / (sec / 3600);
        this.view.average_speed = isNaN(result) ? "0.0" : result.toFixed(1);
        return this.view.average_speed;
    }

    getDeepDistance() {
        let d = (typeof this.locater !== "undefined") ? this.locater.getSumDistance() : 0;
        if (this.trackingService.options.distanceUnit == DistanceUnit.MILES) {
            d = d * 0.621371;
        }
        return (d / 1000).toFixed(2);
    }

    public get distanceUnit(): typeof DistanceUnit {
        return DistanceUnit;
    }

    getLocater() {
        return this.locater;
    }

    setContollerScope(s) {
        this.controllerScope = s;
    }

    getControllerScope() {
        return this.controllerScope;
    }

    setLocalConfig(o) {
        this.localConfig = o;
    }
}





// WEBPACK FOOTER //
// /src/tracker/sencha-tracker/stracker.ts